import { ITask } from '@modules/TasksModule/types';
import { BodyText, Card, Divider } from '@servicetitan/design-system';
import { Flex } from '@servicetitan/anvil2';
import classNames from 'classnames';
import datetime from '@lib/utils/datetime';
import EllipseAdornment from '@pages/agent/InboxPage/components/TaskRow/EllipseAdornment/EllipseAdornment';
import styles from './SpeedToLeadTaskRow.module.css';
import { SpeedToLeadTaskAttributes } from '@modules/SpeedToLeadTasksModule/types';

export interface SpeedToLeadTaskRowProps {
  task: ITask;
  active: boolean;
  onClick: () => void;
}

export const SpeedToLeadTaskRow: React.FC<SpeedToLeadTaskRowProps> = ({
  task,
  active,
  onClick,
}) => {
  const attributes = task.attributes as SpeedToLeadTaskAttributes;
  const address = attributes.contact.address;
  const addressString = [
    address.street,
    address.unit,
    address.city,
    address.state,
    address.zip,
  ]
    .filter(Boolean)
    .join(', ');

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <div data-testid={task.id}>
      <Card
        elevation='base'
        sharp
        onClick={handleClick}
        className={classNames(styles.taskCard, {
          [styles.taskCardActive]: active,
        })}
      >
        <Flex direction='column' gap='1'>
          <Flex justifyContent='space-between' alignItems='center'>
            <BodyText size='small' bold={active}>
              {task.displayName}
            </BodyText>
            <EllipseAdornment>
              <BodyText size='xsmall' subdued>
                {datetime(task.startedAt).format('h:mma')}
              </BodyText>
            </EllipseAdornment>
          </Flex>

          <BodyText size='xsmall' subdued>
            {addressString}
          </BodyText>

          <BodyText size='xsmall' subdued>
            Type: {attributes.action}
          </BodyText>
        </Flex>
      </Card>
      <Divider spacing='0' />
    </div>
  );
};
